import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/translation/catalog/translation.aiFill.mutation.gql"
import type {
  TranslationAiFillMutation,
  TranslationAiFillMutationVariables,
} from "@/v2-backoffice-client/translation/catalog/__types__/translation.aiFill.mutation"

type Options = MutationHookOptions<
  TranslationAiFillMutation,
  TranslationAiFillMutationVariables
>

export function useTranslationAiFillMutation(options?: Options) {
  // No refetchQueries: callers patch the cached catalog with the texts the
  // mutation echoes back (translation.catalog.cache.ts) — a full catalog
  // refetch per call would leave the ~8k-row table stale for seconds.
  return useMutation<
    TranslationAiFillMutation,
    TranslationAiFillMutationVariables
  >(mutation, options)
}
